import { useRouter } from "next/router";

import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import { Button, Container, Typography } from "@mui/material";
import Header from "../components/Header/Header";
import BecomeaTeacherBanner from "../components/MainWebsiteComponent/BecomeTeacherBanner/BecomeTeacherBanner";
import BenifitsOfTeaching from "../components/MainWebsiteComponent/BenifitsOfTeaching/BenifitsOfTeaching";
import WhyTeachOnTakbir from "../components/MainWebsiteComponent/WhyTeachOnTakbir/WhyTeachOnTakbir";
import HowToStart from "../components/MainWebsiteComponent/HowToStart/HowToStart";
import Faq from "../components/Faq/Faq";
import Footer from "../components/MainWebsiteComponent/Footer/Footer";
import Head from "next/head";
import { getUserData } from "../hooks/HelperFunctions";
import { apiRequest } from "../utils/axiosInstance";
import { useState } from "react";
import SimpleBackdrop from "../components/Backdrop/SimpleBackdrop";

const BecomeaTeacher = (props) => {
  const theme = useTheme();
  const router = useRouter();

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const {
    subdomain,
    updateCart,
    setUpdateCart,
    openSignUpModel,
    setOpenSignUpModel,
  } = props;

  const redirectToForm = () => {
    const userAuthenticated = localStorage.getItem("userAuthenticated");

    if (userAuthenticated) {
      router.push("/create-new-teaching-account");
    } else {
      router.push("/get-in-touch");
    }
  };

  const faqData = [
    {
      id: "1",
      qus: "Who can teach on Takbir?",
      ans: "Anyone with knowledge of the Deen, whether affiliated with an institute or not, can teach on Takbir.",
    },
    {
      id: "2",
      qus: "Do you offer any resources for teachers?",
      ans: "Yes, Takbir provides valuable resources for teachers, including support pages with step-by-step instructions and guidance. Additionally, our Teaching Resource and Success Team (TRST) is dedicated to assisting you throughout your teaching journey.",
    },
    {
      id: "3",
      qus: "How do I create a course?",
      ans: "To create a course on Takbir, choose whether to host live sessions or use pre-recorded videos. Team up with our Teaching Resource and Success Team (TRST) for guidance at every step. Share your expertise by teaching what you know best.",
    },
    {
      id: "4",
      qus: "Do we offer certificates to teachers?",
      ans: "Certainly, we provide badges to teachers based on their performance. These badges include distinctions like 'Top Teacher,' 'Rising Teacher,' and 'Top 10 Teacher of the Year' to recognize and celebrate teachers’ accomplishments and achievements.",
    },
    {
      id: "5",
      qus: "How do I become a successful instructor on Takbir?",
      ans: (
        <div>
          To become a successful instructor on Takbir:
          <ol>
            <li>Choose a subject you know the best.</li>
            <li>Create high-quality content.</li>
            <li>Engage with learners actively.</li>
            <li>
              Optimize your course presentation, ensuring clear communication.
            </li>
          </ol>
          Additionally, don't hesitate to reach out to the Teaching Resource and
          Success Team (TRST) for any guidance along the way. They are here to
          support you in your teaching journey.
        </div>
      ),
    },
    {
      id: "6",
      qus: "How do I promote my course?",
      ans: "You can generate a unique URL for your course to facilitate easy sharing on social media or within your network. Additionally, you may opt for the expertise of the Teaching Resource and Success Team (TRST) to promote your course to a global audience through effective marketing strategies, thereby boosting visibility and enrollment.",
    },
    {
      id: "7",
      qus: "Can someone teach on my Takbir teaching account?",
      ans: "Yes, another individual can teach on your Takbir teaching account, but this person needs to be a team member affiliated with your account. However, it's required that at least 75% of the course sessions are taught by the account/teaching account owner.",
    },
    {
      id: "8",
      qus: "Tell me more about Teaching Resource and Success Team (TRST)",
      ans: "The Teaching Resource and Success Team (TRST) is your dedicated one-on-one support team to connect with learners worldwide. With years of experience in content optimization, video recording & editing, digital marketing, and technical support, they guide you through each step, offering expertise in both course creation and promotion. Feel free to reach out for any assistance, from course creation to management; the Teaching Resource and Success Team (TRST) is here to support you at every stage of your teaching journey.",
    },
  ];

  const getStartedHandler = async () => {
    const userInfo = getUserData()

    if (userInfo && Object.keys(userInfo).length > 0) {

      setOpenBackdrop(true); // show loading spinner/backdrop

      try {
        const postData = {};
        const response = await apiRequest("/generateLoginCode", "POST", postData);

        const { code } = response;

        if (code) {

          // Construct Become a teacher URL with code
          const appBUrl = `${process.env.NEXT_PUBLIC_BECOME_A_TEACHER_URL}?code=${encodeURIComponent(code)}`;


          window.location.href = appBUrl;
        } else {
          console.error("No code returned from API");
        }

      } catch (error) {
        console.error("Error generating login code:", error);
      } finally {
        setOpenBackdrop(false);
      }
    } else {
      console.log("No user found");

      sessionStorage.setItem("from_become_a_teacher", true);

      setOpenSignUpModel(true)
    }

  }







  /**
   * close backdrop
   */
  const handleCloseBackdrop = () => {
    setOpenBackdrop(false);
  };

  return (
    <>
      <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />
      <Head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="robots"
          content={
            process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <meta
          name="googlebot"
          content={
            process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <meta name="referrer" content="no-referrer-when-downgrade" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />

        <title>Takbir - Best online Islamic learning and teaching site</title>
        <meta
          name="description"
          content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
        />
        <meta
          property="og:site_name"
          content="Takbir - Best online Islamic learning and teaching site "
        />
        <meta
          property="og:description"
          content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:url" content="https://mytakbir.com/" />
        <meta
          property="og:title"
          content="Takbir - Best online Islamic learning and teaching site"
        />
        <meta
          property="og:image"
          content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
        />

        <link
          rel="icon"
          href="https://cdn.mytakbir.com/static-assets/meta/takbir-lms-learning-management-system-muslim-favicon.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon.ico" />
        {/* <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" /> */}

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-7XY3WGDSHE"
        ></script>

        <script id="google-analytics" strategy="afterInteractive">
          {`
                            window.dataLayer = window.dataLayer || [];
                               function gtag(){window.dataLayer.push(arguments);}
                                gtag('js', new Date());
                                   gtag('config', 'G-7XY3WGDSHE');
                                  `}
        </script>

        <script id="mixpanel" strategy="afterInteractive">
          {`
                (function(e,c){if(!c.__SV){var l,h;window.mixpanel=c;c._i=[];c.init=function(q,r,f){function t(d,a){var g=a.split(".");2==g.length&&(d=d[g[0]],a=g[1]);d[a]=function(){d.push([a].concat(Array.prototype.slice.call(arguments,0)))}}var b=c;"undefined"!==typeof f?b=c[f]=[]:f="mixpanel";b.people=b.people||[];b.toString=function(d){var a="mixpanel";"mixpanel"!==f&&(a+="."+f);d||(a+=" (stub)");return a};b.people.toString=function(){return b.toString(1)+".people (stub)"};l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders start_session_recording stop_session_recording people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
                for(h=0;h<l.length;h++)t(b,l[h]);var n="set set_once union unset remove delete".split(" ");b.get_group=function(){function d(p){a[p]=function(){b.push([g,[p].concat(Array.prototype.slice.call(arguments,0))])}}for(var a={},g=["get_group"].concat(Array.prototype.slice.call(arguments,0)),m=0;m<n.length;m++)d(n[m]);return a};c._i.push([q,r,f])};c.__SV=1.2;var k=e.createElement("script");k.type="text/javascript";k.async=!0;k.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===
                e.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";e=e.getElementsByTagName("script")[0];e.parentNode.insertBefore(k,e)}})(document,window.mixpanel||[])

                mixpanel.init('60e7a8f3c95c4e2b186ace1f2dc5aa09', {
                  autocapture: true,
                  record_sessions_percent: 100,
                })
                `}
        </script>
      </Head>
      <Header
        subdomain={subdomain}
        updateCart={updateCart}
        setUpdateCart={setUpdateCart}
        openSignUpModel={openSignUpModel}
        setOpenSignUpModel={setOpenSignUpModel}
      />
      <BecomeaTeacherBanner
        redirectToForm={redirectToForm}
        setOpenSignUpModel={setOpenSignUpModel}
        getStartedHandler={getStartedHandler} />

      <BenifitsOfTeaching />
      <WhyTeachOnTakbir
        QuestionArr={QuestionArr}
        QuestionAnsArr={QuestionAnsArr}
        redirectToForm={redirectToForm}
        getStartedHandler={getStartedHandler}
      />
      <HowToStart redirectToForm={redirectToForm} getStartedHandler={getStartedHandler} />
      <Faq faqData={faqData} />
      <Container sx={{ mt: 10, textAlign: "center" }}>
        <Typography
          variant="h3"
          sx={{
            margin: "0 auto",
            width: "40%",
            fontSize: "60px",
            fontWeight: "600",
            [theme.breakpoints.down("sm")]: {
              width: "80%",
              fontSize: "30px",
            },
          }}
        >
          Ready to Start Teaching?
        </Typography>
        <StyledButton variant="contained" onClick={(e) => getStartedHandler()}>
          Get Started
        </StyledButton>
      </Container>
      <Footer />
    </>
  );
};

export default BecomeaTeacher;

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "10px !important",
  padding: "14px 46px !important",
  color: "#fff !important",
  background: "#004FE0 !important",
  boxShadow: "none !important",
  borderRadius: "10px !important",
  "&:hover": {
    background: "#004FE0 !important",
    boxShadow: "none !important",
  },
  [theme.breakpoints.down("sm")]: {},
}));

const QuestionArr = [
  "Transparency",
  "Course Management",
  "Teaching Team Coordination",
  "Diploma & Certificate Track",
  "Reach Global Learners",
  "Secured Communications",
  "Acknowledgement for your efforts",
  "Promotions and Coupons",
];

const QuestionAnsArr = [
  {
    title:
      "Explore a transparent dashboard presenting key data such as number of enrollments, and detailed statistics on learners, courses, and payments.",
    // img: "https://mytakbir-assets-public.s3.amazonaws.com/sayhan/courses/Session-img.b80618f55f18911b135a.png",
  },
  {
    title:
      "Simplify your teaching journey with our secured and user-friendly Course Management modules. Organize, edit, and customize your free or paid courses effortlessly to match your teaching approach.",
    // img: "https://mytakbir-assets-public.s3.amazonaws.com/sayhan/courses/Session-img.b80618f55f18911b135a.png",
  },
  {
    title:
      "Easily coordinate with your teaching team using our collaborative platform. Assign them roles such as teaching assistant or admin, delegate tasks, and manage permissions for effective and synchronized teamwork.",
    img: "",
  },
  {
    title: (
      <div>
        Create a specialized diploma curriculum guiding learners throughout.{" "}
        <br />
        <br />
        Award your learners with certificates or Diploma upon completion,
        recognizing their expertise and accomplishment in the course.
      </div>
    ),
    // img: "https://mytakbir-assets-public.s3.amazonaws.com/sayhan/courses/Session-img.b80618f55f18911b135a.png",
  },
  {
    title: (
      <div>
        Spread your knowledge of Deen to global learners, promoting your courses
        worldwide. Create a global presence with learners from different corners
        of the world, fulfilling your duty of Dawah. <br />
        Our Teaching Resource and Success Team (TRST) is always here to help you
        achieve your goals.{" "}
      </div>
    ),
    img: "",
  },
  {
    title:
      "Takbir Inbox ensures secure communication with your internal teaching team and learners for course-related messages, announcements, and updates in one secured space. ",
    // img: "https://mytakbir-assets-public.s3.amazonaws.com/sayhan/courses/Session-img.b80618f55f18911b135a.png",
  },
  {
    title: (
      <div>
        Join Takbir for rewarding opportunities, acknowledging your teaching
        efforts as a stable and dependable source. Enjoy stability while sharing
        knowledge and impacting lives globally. <br />
        <i>
          <b>Optionally,</b>you can choose to donate your earnings to a cause
          you care about. Pick your preferred organization on our admin
          portal—whether it's a non-profit or another worthy cause, making a
          positive impact globally.
        </i>
      </div>
    ),
  },
  {
    title:
      "Create promotions, enable coupons, and offer discounts such as Ramadan discounts or Eid offers to enhance course visibility and enrollment in your courses. ",
  },
];
